import React, { memo } from 'react';
import { View } from 'react-native';
import T from 'prop-types';
import s from './styles';
import { colors } from '../../../../../../../styles';
import { Text, TouchableItem } from '../../../../../../ReusableComponents';
import strings from '../../../../../../../localization';
import { getCurrentTheme } from '../../../../../../../templates';

const DISTANCE_OPTIONS = [1, 5, 10, 20];

const Distance = memo(({ distanceValue, onSelectDistance }) => {
  const currentTheme = getCurrentTheme();
  return (
    <View style={s.contentContainer}>
      {DISTANCE_OPTIONS.map((distance) => {
        const isActive = distance === distanceValue;

        return (
          <TouchableItem
            key={distance}
            style={[
              s.itemContainer,
              isActive && {
                backgroundColor: currentTheme.colors.secondary,
                borderColor: currentTheme.colors.secondary,
              },
            ]}
            onPress={() => onSelectDistance(distance)}
          >
            <Text color={isActive ? colors.white : null}>
              {distance} {strings.locations.km}
            </Text>
          </TouchableItem>
        );
      })}
    </View>
  );
});

Distance.propTypes = {
  distanceValue: T.number,
  onSelectDistance: T.func,
};

export default Distance;
